export enum UserRole {
  SUPER_ADMIN = 'Super Admin',
  ADMIN = 'ADMIN',
  CONTROLLER = 'CONTROLLER',
  CLEARER = 'CLEARER',
}

// Helper function to check if user has admin privileges (Super Admin or Admin)
export const isAdmin = (role: UserRole | Role | string | undefined): boolean => {
  if (!role) return false;
  const roleName = typeof role === 'string' ? role : (typeof role === 'object' && 'name' in role ? role.name : '');
  return roleName === 'Super Admin' || roleName === 'ADMIN' || roleName === 'System Administrator' || roleName === 'Administrator';
};

// Helper function to check if user is Super Admin
export const isSuperAdmin = (role: UserRole | Role | string | undefined): boolean => {
  if (!role) return false;
  const roleName = typeof role === 'string' ? role : (typeof role === 'object' && 'name' in role ? role.name : '');
  return roleName === 'Super Admin';
};

export interface Role {
  id: string;
  name: string;
  description?: string;
  isSystem?: boolean;
}

export interface User {
  id: string;
  email: string;
  username?: string | null;
  name: string;
  role: UserRole | Role | string; // Support both enum and object
  isActive: boolean;
  lastLogin?: string;
  createdAt: string;
  userSkills?: UserSkill[];
}

export interface UserSkill {
  id: string;
  skill: Skill;
}

export interface Skill {
  id: string;
  name: string;
  description?: string;
  createdAt?: string;
}

export interface AuthResponse {
  user: User;
  accessToken: string;
}

export interface AuthState {
  user: User | null;
  accessToken: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}
